import React from "react";

export default function Footer() {
  return (
    <footer
      style={{
        backgroundColor: "#f1f1f1",
        padding: "12px",
        textAlign: "center",
        borderTop: "1px solid #ddd",
        marginTop: "40px"
      }}
    >
      <strong>
        © 2024 Panjab University, Chandigarh — Welcome: Panjab University
      </strong>
    </footer>
  );
}
